import React from 'react';
import styled from 'styled-components';
import parse from 'html-react-parser';

import { isRTL } from '_helpers';
import { colors } from '_styles';

const Paragraph = styled.div`
    all: initial;
  font-family: Roboto, sans-serif !important;
     
    display: block;
    line-height: 1.7em;
    font-weight: 500 !important;
    font-size: 15px !important;
    color: #000000;
    direction: ${() => (isRTL() ? 'rtl' : 'ltr')};

    p, ul, li {
    line-height: 1.7em;
    color: #666;
    }

    title {
    display: block !important;
    font-size: 20px !important;
     
    align-self: center;
    font-weight: 200 !important;
    margin-bottom: 10px;
    }

    b {
    font-weight: bold !important;
    }

    a {
      color: ${colors.RC_ACTION} !important;

      &:hover {
        color: ${colors.RC_ACTION} !important;
      }
    }
`;

const Description = ({ children }) => (
  <Paragraph>
    {parse(children)}
  </Paragraph>
);

export default Description;
